<template>
  <section id="businessContactInfo">
    <div class="container">
      <div class="header">
        <h5>Business</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#" autocomplete="off">
        <h5>Who can we contact at {{companyName}}?</h5>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="contactPerson">
                Contact Person
                <span>*</span>
              </label>
              <input
                :disabled="loading"
                v-validate="'required'"
                v-model="contactPerson"
                id="contactPerson"
                class="input"
                type="text"
                required
                v-on:keyup.enter="focusOut($event)"
              >
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control">
              <label for="email">
                Email Address
                <span>*</span>
              </label>
              <input
                :disabled="loading"
                v-validate="'required|email'"
                v-model="email"
                :class="{'invalid': emailExists}"
                @focus="clearError('email')"
                id="email"
                class="input"
                type="email"
                required
                v-on:keyup.enter="focusOut($event)"
              >
              
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="mobile">
                Mobile Number
                <span>*</span>
              </label>
              <input
                :disabled="loading"
                v-validate="'required'"
                v-model="mobile"
                @focus="clearError('mobile')"
                id="mobile"
                class="input"
                :class="{'invalid': mobileExists}"
                type="tel"
                v-mask="'### ### ####'"
                required
                v-on:keyup.enter="focusOut($event)"
              >
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control">
              <label for="workNum">
                Work Phone Number
                
              </label>
              <input
                :disabled="loading"
                v-mask="'### ### ####'"
                v-model="workNum"
                id="workNum"
                class="input"
                type="tel"
                required
                v-on:keyup.enter="focusOut($event)"
              >
            </div>
          </div>
        </div>
      <div class="errorContainer">
        <div v-if="emailExists">The email address has been registered previously on our system. Please use another email address.</div>
        <div v-if="mobileExists">This mobile number has been registered previously on our system. Please use another mobile number.</div>
      </div>
      </form>

      <div class="actions">
        <button @click="back()" class="button" :disabled="loading">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button @click="toBusinessAddress()" class="button is-danger" :class="{'is-loading': loading}">Continue</button>
      </div>
    </div>
  </section>
</template>

<script>
import CancelButton from "../../components/actions/CancelButton";
import * as Sentry from "@sentry/browser";

import alertify from "alertifyjs";
import axios from "axios";
import { mask } from "vue-the-mask";
export default {
  name: "businessContactInfo",
  directives: { mask },
  data() {
    return {
      contactPerson: null,
      email: null,
      mobile: null,
      workNum: null,
      emailExists: false,
      mobileExists: false,
      loading: false
    };
  },
  components: {
    CancelButton
  },
  methods: {
    toBusinessAddress() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
        } else {
          this.loading = true
          if(process.env.NODE_ENV == "staging"){
            this.$store.commit("SAVE_BUSINESS_CONTACT", {
                  contactPerson: this.contactPerson,
                  email: this.email,
                  mobile: this.mobile,
                  workNum: this.workNum
                });
              this.$router.push("/businessaddress");
              return
          }
          axios
            .post(
              this.$store.state.apiBaseUrl + "/check",
              {mobile: this.mobile, email: this.email}
            )
            .then(() => {
              this.loading = false
              this.$store.commit("SAVE_BUSINESS_CONTACT", {
                  contactPerson: this.contactPerson,
                  email: this.email,
                  mobile: this.mobile,
                  workNum: this.workNum
                });
              this.$router.push("/businessaddress");
            })
            .catch(err => {

              if(err.response && err.response.status == 422){
                // Error if email or mobile exists on api
                let errorMessage = err.response.data.errors
                if(errorMessage.email && errorMessage.email.length > 0){
                  alertify.error("Email already used")
                  this.emailExists = true
                }
                if(errorMessage.mobile && errorMessage.mobile.length > 0){
                  alertify.error("Mobile already used")
                  this.mobileExists = true
                }
              } else {
                alertify.error("An error occured trying to verify email and mobile number. Please check internet connection or contact support.");
                Sentry.captureException(err);
                console.error(err)
              }
              this.loading = false
            })

        }
      });
    },
    back() {
      document.body.classList.add("transitionBack");

      this.$router.go(-1);

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    },
    clearError(type){
      if(type == 'email'){
        this.emailExists = false
      }
      if(type == 'mobile'){
        this.mobileExists = false
      }
    }
  },
  computed: {
    companyName() {
      return this.$store.state.business.info.tradingName;
    }
  },
  mounted() {
    this.contactPerson = this.$store.state.business.contact.contactPerson
    this.email = this.$store.state.business.contact.email
    this.mobile = this.$store.state.business.contact.mobile
    this.workNum = this.$store.state.business.contact.workNum


  }
};
</script>
